import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./App.css";

import Aboutus from "./Component/Aboutus";
import Home from "./Component/Home";
import PortFolio from "./Component/Portfolio";
import Services from "./Component/Services";
import TeamSection from "./Component/Team";
import Faqs from "./Component/Faqs";
import Process from "./Component/Process";
import Contact from "./Component/Contactus";
import FooterNav from "./Component/FooterNavbar";
import GoogleMapEmbed from "./Component/GoogleMap";
import PrivacyPolicy from "./Component/PrivacyPolicy"; 
import Terms from "./Component/TermsCondition";
import Canclellation from "./Component/Cancellation";
import Shipping from "./Component/Shippng";
import GoogleMapWithContactForm from "./Component/GoogleMap";
import Index from "./Component/New";
import ChristmasOffer from "./Component/New";

const App = () => {
  const [showFooter, setShowFooter] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleContactClick = () => setIsPopupOpen(true);

  // Scroll-based footer visibility
  useEffect(() => {
    const handleScroll = () => {
      const hero = document.getElementById("home");
      const services = document.getElementById("services");
      const contact = document.getElementById("contact");

      if (hero && services && contact) {
        const heroBottom = hero.getBoundingClientRect().bottom;
        const servicesTop = services.getBoundingClientRect().top;
        const contactTop = contact.getBoundingClientRect().top;

        const hasScrolledPastHero =
          heroBottom <= 2 || servicesTop <= window.innerHeight / 2;
        const footerIsInView = contactTop < window.innerHeight;

        setShowFooter(hasScrolledPastHero && !footerIsInView);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Prevent right-click, copy, select
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
      alert("Right-click is disabled. Copying content is not allowed.");
    };
    const handleCopy = (e) => {
      e.preventDefault();
      alert("Copying content is disabled.");
    };
    const handleSelectStart = (e) => {
      e.preventDefault();
      alert("Text selection is disabled.");
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("copy", handleCopy);
    document.addEventListener("selectstart", handleSelectStart);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("copy", handleCopy);
      document.removeEventListener("selectstart", handleSelectStart);
    };
  }, []);

  // Main single-page layout component
  const MainPage = () => (
    <div style={{ userSelect: "none" }}>
      <Helmet>
        <title>DesignVio | UX & Full Stack Development Courses and Development</title>
        <meta
          name="description"
          content="DesignVio offers premium UI/UX and Full Stack Development courses in Satara."
        />
        <meta
          name="keywords"
          content="DesignVio, UIUX Courses, Full Stack Developers, Satara, Karanje Satara"
        />
        <link rel="canonical" href="https://designvio.in/" />
        <meta property="og:title" content="DesignVio | UX Design Agency" />
        <meta
          property="og:description"
          content="DesignVio offers premium UI/UX and Full Stack Development courses in Satara."
        />
        <meta property="og:url" content="https://designvio.in/" />
        <meta
          property="og:image"
          content="https://designvio.in/preview-image.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {/* Hero Section */}
      <div className="heroSection" id="home">
        <Home onContactClick={handleContactClick} />
      </div>

      {/* Services Section */}
      <div className="back-container">
        <div className="page2" id="services">
          <Services onContactClick={handleContactClick} />
        </div>

        {/* Other Sections */}
        <div className="page3">
          <div id="about"><Aboutus /></div>
          <div id="work"><PortFolio /></div>
          <div id="team"><TeamSection /></div>
          <div id="faqs"><Faqs /></div>
          <div id="process"><Process /></div>
          {/* <GoogleMapWithContactForm /> */}
          <div id="contact"><Contact /></div>
        </div>
      </div>

      <div id="footer">
        {showFooter && <FooterNav onContactClick={handleContactClick} />}
      </div>
    </div>
  );

  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contactus" element ={<GoogleMapWithContactForm/>}/>
        <Route path="/terms-conditons" element={<Terms/>}/>
        <Route path="/cancellation" element={<Canclellation/>}/>
        <Route path="shipping" element={<Shipping/>}/>
        <Route path="photoshoot" element={<ChristmasOffer/>}/>

      </Routes>
    </Router>
  );
};

export default App;
